import React from "react";
import { determinePagePlatform } from "../nav-util/ga4";
var NavAgentCustomer = function NavAgentCustomer(_ref) {
  var title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    type = _ref.type;
  return type === "slim" ? /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-agent',
    id: "NavAgentCustomer-".concat(determinePagePlatform()),
    href: href,
    target: '_blank',
    onClick: onClick,
    rel: 'noreferrer'
  }, title) : null;
};
export default NavAgentCustomer;